import type {ReactNode} from "react";

type Props = {
  icon: string;
  title: string;
  children: ReactNode;
};

export function PdpInfoCard({icon, title, children}: Props) {
  return (
    <section className="pvPdpInfoCard">
      <header className="pvPdpInfoCard__head">
        <span className="pvPdpInfoCard__icon" aria-hidden="true">
          <i className={`fa ${icon}`} />
        </span>
        <h2 className="pvPdpInfoCard__title">{title}</h2>
      </header>
      <div className="pvPdpInfoCard__body">{children}</div>
    </section>
  );
}
